import SectionPage from "./SectionPage";
import WhoWeServe from "./WhoWeServe";

export const WhoWeServePage = () => (
  <SectionPage
    eyebrow="Who We Serve"
    title="Built for More Than Parties"
    subtitle="From DOE-vendor school programs to corporate offices, agency meetings, production shoots, and airport concessions — we're built to scale across NYC and Long Island."
    hero="charcoal"
  >
    <WhoWeServe compact />
  </SectionPage>
);

export default WhoWeServePage;
